import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { addPx } from "./utils";
export var _minTapSize_ = 44;
export var minTapSize = addPx(_minTapSize_);
var iSize = {
  viewBox: 24,
  margin: 10,
  padding: 3
};
var _iconSize_ = _objectSpread(_objectSpread({}, iSize), {}, {
  // We use a type assertion here to get the exact number value in the type
  total: iSize.viewBox + iSize.margin * 2
});
var iconSize = addPx(_iconSize_);
export { _iconSize_, iconSize };